import { render, staticRenderFns } from "./DPDFPopup.vue?vue&type=template&id=6f4f3ddb&scoped=true&"
import script from "./DPDFPopup.vue?vue&type=script&lang=js&"
export * from "./DPDFPopup.vue?vue&type=script&lang=js&"
import style0 from "./DPDFPopup.vue?vue&type=style&index=0&id=6f4f3ddb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4f3ddb",
  null
  
)

export default component.exports